import { NavLink } from "react-router-dom";
import Numeralia from "../components/Numeralia";
import logo from "../assets/casate22.gif";
import palco from "../assets/escalones.png";
import registro_btn from "../assets/boton.png";
// import titulo from "../assets/titulo.png";
import React, { useEffect } from "react";

  const Index = () => {
    useEffect(() => {

    let now = new Date();
    let hour = now.getHours();
    let day = now.getDate();
    let month = now.getMonth() + 1;
    let year = now.getFullYear();
    let btnRegistro = document.getElementById("btnRegistro");
    
    if(day >= 1 && day <= 29 && month === 7 && year === 2022){
      btnRegistro.style.cssText = "display:block;";
    }
    else{
      btnRegistro.style.cssText = "display:none;";
    }
  }, []);

  return (
    <>
      <div className="container marginHome">
        {/* <div className="containerTelon">
          <div className="telon"></div>
        </div> */}
        <div className="row justify-content-center">
          <div className="col index__container text-center">
	  		<h1 class="main_title">ESTA VEZ</h1>
	  		<h1 class="main_title">CON EL AMOR SÍ SE JUEGA...</h1>
            <div className="mt-4">
              <img
                className="index__logo"
                alt="logo"
                src={logo}
              />
            </div>
            <div className="mt-0 mb-5">
              <img
                className="logo_palco w-100"
                alt="logo"
                src={palco}
              />
            </div>
            <div className="my-3">
              <div className="my-3">
                <h1 className="index__title mx-auto">
                  La boda más espectacular del año puede ser tuya. Cuéntanos tu historia de amor y nosotros ponemos el resto.
                </h1>
                <h1 className="index__title mx-auto m-0 px-5 mb-5"></h1>
              </div>
              <div className="my-3" id="btnRegistro">
              <NavLink className="nav-link" activeClassName="activeLink" to="/registro">
                <img src={registro_btn} alt="Boton Registro"/>
              </NavLink>
              </div>
              <div className="my-3">
                <h1 className="index__title mx-auto">
                  DGRTC/0695/2022
                </h1>
              </div>
              <div className="my-3">
                {/* <span>DGRTC/0193/19</span> */}
                <h3 className="mt-5 px-5 text-white index_title_numeralia">¿CÓMO VAN LAS PROPUESTAS DE ESTE CÁSATE?</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="container-fluid">
        <div className="row">
          <img
            className="index__icon_video"
            src={process.env.PUBLIC_URL + "/img/icon-video.svg"}
          />
          <img
            className="d-none d-lg-block index__video_cover"
            src={process.env.PUBLIC_URL + "/img/video-desktop.png"}
          />
          <img
            className="d-lg-none index__video_cover"
            src={process.env.PUBLIC_URL + "/img/video-mobile.png"}
          />
        </div>
      </div> */}
      <div className="container">
        <div className="row justify-content-center">
          <Numeralia />
        </div>
      </div>
    </>
  );
};

export default Index;
